var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resize-slider",class:{
    active: _vm.isActive
  },on:{"mousedown":_vm.onMouseDown}},[_c('i',{staticClass:"pause-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }